import { render } from "./ListCutoff.vue?vue&type=template&id=b9121eaa"
import script from "./ListCutoff.vue?vue&type=script&lang=js"
export * from "./ListCutoff.vue?vue&type=script&lang=js"

import "./ListCutoff.vue?vue&type=style&index=0&id=b9121eaa&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__